<template>
  <div class="comparison">
    <div class="comparison-toolbar">
      <v-btn class="pa-0" color="secondary" min-width="32" text @click="handleBack">
        <v-icon size="16">$vuetify.icons.chevron-left</v-icon>
      </v-btn>
      Comparison: {{ images.length || 0 }} / {{ total }}
    </div>
    <loader v-if="loading && !images.length" />
    <layout-with-scrollbar v-else @scrollEnd="handleScroll">
      <comparison-gallery
        v-if="images.length"
        :comparisons="images"
        @removeCompare="removeCompare"
      />
      <div v-else class="empty-data">
        <span>No Comparisons created yet...</span>
      </div>
    </layout-with-scrollbar>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { deleteCompare, getComparesRaceImages } from '../../api/compares'
import ComparisonGallery from './ComparisonGallery'
import LayoutWithScrollbar from '@/components/layout/LayoutWithScrollbar'
import Loader from '@/components/Loader'

export default {
  name: 'Race',
  components: {
    ComparisonGallery,
    LayoutWithScrollbar,
    Loader,
  },
  computed: {
    raceId() {
      return this.$route.params.raceId
    },
  },
  data() {
    return {
      images: [],
      imagesLimit: 25,
      page: 1,
      loading: false,
      more: true,
      total: 0,
    }
  },
  methods: {
    ...mapActions ({
      notificationError: 'notification/error',
      notificationSucces: 'notification/success',
    }),
    async getData(page = 1) {
      try {
        this.loading = true
        const { data } = await getComparesRaceImages(this.raceId, {
          limit: this.imagesLimit,
          order: '-created_date',
          page,
        })

        this.images.push(...data.compares)
        this.more = this.images.length < data.total
        this.page = page
        this.total = data.total
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false
      }
    },
    handleBack() {
      this.$router.go(-1)
    },
    handleScroll() {
      if (this.more) {
        this.getData(this.page + 1)
      }
    },
    async removeCompare(deletedId) {
      try {
        const { status } = await deleteCompare({ compares_ids: deletedId })
        if (status === 204) {
          this.notificationSucces('The comparison was deleted.')
          this.images = this.images.filter(el => el.compare_id !== deletedId)
          this.total = this.total - 1
        }
      } catch (e) {
        console.log(e);
        this.notificationError('Failed to delete the comparison.')
      }
    },
    updatePage() {
      this.getData()
    },
  },
  mounted() {
    this.updatePage()
  }
}
</script>

<style lang="scss" scoped>
.comparison {
  background-color: var(--v-grey-lighten-5);
}

.comparison-toolbar {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 9px 16px;
  background: var(--v-blue-lighten-4);
  border-bottom: 1px solid var(--v-blue-lighten-2);
  color: var(--v-primary-base);
  font-weight: 500;
}

.empty-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  color: var(--v-grey-lighten-2);
  font-size: 18px;
  font-weight: 500;
}
</style>
